import { defineStore } from 'pinia';
import instructionService from '@/api/instructionService';

export const useInstructionStore = defineStore('instruction', {
  state: () => ({
    instructions: [],
    currentInstruction: null,
    totalInstructions: 0,
    currentPage: 1,
    size: 10,
    isLoading: false,
  }),
  actions: {
    // Fetch all instructions with pagination
    async fetchInstructions(page = 1, size = 10) {
      this.isLoading = true;
      try {
        const { data } = await instructionService.getInstructions(page, size);
        this.instructions = data.items;
        this.totalInstructions = data.total;
        this.currentPage = page;
        this.size = size;
      } catch (error) {
        console.error('Error fetching instructions:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

     // Fetch a single instruction by ID
     async fetchInstructionById(instructionId) {
      this.isLoading = true;
      try {
        const { data } = await instructionService.getInstructionById(instructionId);
        this.currentInstruction = data || null; // Set the instruction to currentInstruction
        return this.currentInstruction;
      } catch (error) {
        console.error('Error fetching instruction:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    async searchInstructions(query, page = 1, size = 10) {
      this.isLoading = true;
      try {
        const { data } = await instructionService.searchInstructions(query, page, size);
        this.instructions = data.items;
        this.totalInstructions = data.total;
        this.currentPage = page;
        this.size = size;
      } catch (error) {
        console.error('Error searching instructions:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    // Create a new instruction
    async createInstruction(instructionData) {
      this.isLoading = true;
      try {
        const { data } = await instructionService.createInstruction(instructionData);
        this.instructions.push(data);
      } catch (error) {
        console.error('Error creating instruction:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    // Update an existing instruction
    async updateInstruction(id, instructionData) {
      this.isLoading = true;
      try {
        const { data } = await instructionService.updateInstruction(id, instructionData);
        const index = this.instructions.findIndex(instruction => instruction.id === id);
        if (index !== -1) {
          this.instructions.splice(index, 1, data);
        }
      } catch (error) {
        console.error('Error updating instruction:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    // Delete an instruction
    async deleteInstruction(id) {
      this.isLoading = true;
      try {
        await instructionService.deleteInstruction(id);
        this.instructions = this.instructions.filter(instruction => instruction.id !== id);
      } catch (error) {
        console.error('Error deleting instruction:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
